import { Card, Stack, Typography } from '@mui/material';
import { Icon } from '@/components/shared/icon';

export const EmptyActivitiesList = () => (
  <Card sx={{ height: '100%', p: 2, width: { xs: '100%', sm: 400 } }}>
    <Stack alignItems="center" direction="row" gap={2}>
      <Icon name="tea-cup" size={88} />
      <Typography>
        Adicione sua primeira atividade para começar a montar seu plano.
      </Typography>
    </Stack>
  </Card>
);
